import {jsonp} from 'vue-jsonp'
import request from "@/api/request";

export function openData(params) {
    return jsonp('https://opendata.baidu.com/api.php', params)
}

export function getHoliday(params) {
    return request({
        url: '/api/reptile/holiday',
        method: 'get',
        params: params
    })
}
